import { ThunkDispatch } from "redux-thunk";

import createApiModule from "@/redux/create-api-module";
import { IState, TApiAction, TExtraThunkArgs } from "@/redux/store.types";
import { Config } from "@/utils/config.utils";

import { $StoreDetailsModuleName } from "./storeDetails.types";

const { actions } = createApiModule($StoreDetailsModuleName, ({ url }) => url);
export const clear = actions.clear;

export const load =
    (storeCode: string, force: boolean = false) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) =>
        await dispatch(
            actions.load(
                {
                    path: {
                        url: `/storeservice/${Config.general.basestore}/localized/stores/${storeCode}`
                    }
                },
                "GET",
                force
            )
        );

export const refetch = actions.refetch;
